import { ApfFieldsResponse } from 'orders/ordersService'
import { CustomerInfoValue } from '../types'
import { getCountryName } from 'utils/country'
import { t } from 'translations'

interface PreparedCustomerFields {
    defaultFields: Array<{
        key: string
        label: string
        value: string
    }>
    customFields: Array<{
        key: string
        label: string
        value: string
    }>
    hasVisibleFields: boolean
}

export const prepareCustomerInfoFields = (
    value: CustomerInfoValue,
    apfFieldsKey: ApfFieldsResponse,
    shouldHideBuyerEmail: boolean,
    shouldHideFieldsExceptBuyerEmail: boolean
): PreparedCustomerFields => {
    const defaultFields: Array<{ key: string; label: string; value: string }> = []
    const customFields: Array<{ key: string; label: string; value: string }> = []

    const fullName = [value.buyerFirstName, value.buyerLastName].filter(Boolean).join(' ')
    if (!shouldHideFieldsExceptBuyerEmail && fullName) {
        defaultFields.push({
            key: 'fullName',
            label: t('orders.dailySchedule.fields.name'),
            value: fullName
        })
    }

    if (!shouldHideBuyerEmail && value.buyerEmail) {
        defaultFields.push({
            key: 'buyerEmail',
            label: t('orders.dailySchedule.fields.email'),
            value: value.buyerEmail
        })
    }

    if (!shouldHideFieldsExceptBuyerEmail && value.buyerCountry) {
        defaultFields.push({
            key: 'buyerCountry',
            label: t('orders.dailySchedule.fields.country'),
            value: getCountryName(value.buyerCountry)
        })
    }

    if (!shouldHideFieldsExceptBuyerEmail) {
        Object.entries(apfFieldsKey.default).forEach(([key, fieldValue]) => {
            if (
                !['buyerFirstName', 'buyerLastName', 'buyerEmail', 'buyerCountry'].includes(key) &&
                value[key]
            ) {
                defaultFields.push({
                    key,
                    label: fieldValue,
                    value: value[key]
                })
            }
        })
    }

    if (!shouldHideFieldsExceptBuyerEmail) {
        Object.entries(apfFieldsKey.custom).forEach(([key, fieldValue]) => {
            if (value[key]) {
                customFields.push({
                    key,
                    label: fieldValue,
                    value: value[key]
                })
            }
        })
    }

    return {
        defaultFields,
        customFields,
        hasVisibleFields: defaultFields.length > 0 || customFields.length > 0
    }
}
